import { usePrivy } from '@privy-io/react-auth';

/** Wallet Privy currently holds for the signed-in user (display only). */
export const useConnectedWallet = () => {
    const { ready, authenticated, user } = usePrivy();
    // Privy sets walletClientType 'privy' on the embedded wallet it auto-creates for every user.
    const isExternal = (w) => w && typeof w.address === 'string' && w.walletClientType !== 'privy';
    const externalAccounts = (user?.linkedAccounts || []).filter(
        (a) => a?.type === 'wallet' && isExternal(a)
    );
    // Prefer the wallet Privy marks as active (most recently verified) when it is external,
    // so a partner with several linked wallets sees the one he signed in with.
    const address =
        (isExternal(user?.wallet) ? user.wallet.address : null) ||
        externalAccounts[0]?.address ||
        user?.wallet?.address ||
        null;
    return { address, isConnected: Boolean(ready && authenticated && address) };
};

export default useConnectedWallet;
